import { LearningPath } from '@/types/learning';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface LearningPathSelectionCardProps {
  path: LearningPath;
  learnerCount?: string;
  onSelect: (pathId: string) => void;
}

const getIcon = (iconName: string) => {
  const icons: Record<string, string> = {
    bitcoin: '₿',
    ethereum: 'Ξ',
    solana: '◎',
    defi: '🏦',
    nft: '🖼️',
    dao: '🏛️',
    book: '📚',
    code: '💻',
    rocket: '🚀',
    shield: '🛡️',
  };
  return icons[iconName.toLowerCase()] || '📚';
};

export const LearningPathSelectionCard = ({ 
  path, 
  learnerCount = '10K+ learners',
  onSelect 
}: LearningPathSelectionCardProps) => {
  return (
    <Card
      onClick={() => onSelect(path.id)}
      className={cn(
        "relative overflow-hidden cursor-pointer transition-all duration-300",
        "hover:scale-105 hover:shadow-xl",
        "border-2 border-border/50",
        "group"
      )}
      style={{ 
        backgroundColor: `hsl(var(--card))`,
      }}
    >
      <div className="p-8 flex flex-col items-center text-center space-y-4">
        {/* Large Icon */}
        <div className="text-7xl mb-2 group-hover:scale-110 transition-transform duration-300">
          {getIcon(path.icon ?? '')}
        </div>

        {/* Title */}
        <h3 className="text-2xl font-bold text-foreground">
          {path.title}
        </h3>

        {/* Learner Count */}
        <p className="text-sm text-muted-foreground font-medium">
          {learnerCount}
        </p>

        {/* Category Tag */}
        <div className="inline-block px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-semibold">
          {path.category}
        </div>
      </div>

      {/* Hover Effect Border */}
      <div className="absolute inset-0 border-2 border-primary/0 group-hover:border-primary/50 rounded-xl transition-colors duration-300" />
    </Card>
  );
};
